var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleGame4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 89,
    viewBox: "0 0 60 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.2725 76.588L18.7545 79.01H20.6025V80.41H18.4605L17.9005 83H16.3745L16.9345 80.41H14.1905L13.6305 83H12.1045L12.6645 80.41H10.4945V79.01H12.9585L13.4765 76.588H11.3205V75.188H13.7705L14.3165 72.64H15.8425L15.2965 75.188H18.0405L18.5865 72.64H20.1125L19.5665 75.188H21.4285V76.588H19.2725ZM17.7465 76.588H15.0025L14.4845 79.01H17.2285L17.7465 76.588ZM31.3135 83H29.7175L24.9155 75.734V83H23.3195V73.256H24.9155L29.7175 80.508V73.256H31.3135V83ZM38.6174 78.002C39.14 78.0953 39.5834 78.3707 39.9474 78.828C40.3114 79.2853 40.4934 79.8033 40.4934 80.382C40.4934 80.8767 40.3627 81.3247 40.1014 81.726C39.8494 82.118 39.4807 82.4307 38.9954 82.664C38.51 82.888 37.9454 83 37.3014 83H33.4094V73.27H37.1194C37.782 73.27 38.3514 73.382 38.8274 73.606C39.3034 73.83 39.6627 74.1333 39.9054 74.516C40.148 74.8893 40.2694 75.3093 40.2694 75.776C40.2694 76.336 40.12 76.8027 39.8214 77.176C39.5227 77.5493 39.1214 77.8247 38.6174 78.002ZM35.0054 77.358H36.9794C37.502 77.358 37.908 77.2413 38.1974 77.008C38.496 76.7653 38.6454 76.42 38.6454 75.972C38.6454 75.5333 38.496 75.1927 38.1974 74.95C37.908 74.698 37.502 74.572 36.9794 74.572H35.0054V77.358ZM37.1614 81.698C37.7027 81.698 38.1274 81.5673 38.4354 81.306C38.7434 81.0447 38.8974 80.6807 38.8974 80.214C38.8974 79.738 38.734 79.36 38.4074 79.08C38.0807 78.8 37.6467 78.66 37.1054 78.66H35.0054V81.698H37.1614ZM48.0937 81.012H44.0197L43.3197 83H41.6537L45.1397 73.256H46.9877L50.4737 83H48.7937L48.0937 81.012ZM47.6457 79.71L46.0637 75.188L44.4677 79.71H47.6457Z",
    fill: "#F4F3FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_419_4066)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 16,
    fill: "#FFCAFA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3557 34.16V31.96L24.8957 22.6H28.1557V31.72H29.9157V34.16H28.1557V37H25.3557V34.16H18.3557ZM25.5357 25.6L21.4357 31.72H25.5357V25.6ZM33.4224 24.732V27.948C33.4224 28.172 33.4744 28.336 33.5784 28.44C33.6904 28.536 33.8744 28.584 34.1304 28.584H34.9104V30H33.8544C32.4384 30 31.7304 29.312 31.7304 27.936V24.732H30.9384V23.352H31.7304V21.708H33.4224V23.352H34.9104V24.732H33.4224ZM40.2227 23.256C40.7267 23.256 41.1747 23.368 41.5667 23.592C41.9587 23.808 42.2627 24.132 42.4787 24.564C42.7027 24.988 42.8147 25.5 42.8147 26.1V30H41.1347V26.328C41.1347 25.8 41.0027 25.396 40.7387 25.116C40.4747 24.828 40.1147 24.684 39.6587 24.684C39.1947 24.684 38.8267 24.828 38.5547 25.116C38.2907 25.396 38.1587 25.8 38.1587 26.328V30H36.4787V21.12H38.1587V24.18C38.3747 23.892 38.6627 23.668 39.0227 23.508C39.3827 23.34 39.7827 23.256 40.2227 23.256Z",
    fill: "#2A2A2B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_419_4066",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_419_4066"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_419_4066"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleGame4);
export default __webpack_public_path__ + "static/media/Title Game4.b8f18ca8521323491efb85b97a918963.svg";
export { ForwardRef as ReactComponent };